export const SaveToStorage = (key: string, value: object): void => {
    sessionStorage.setItem(key, JSON.stringify(value));
}

export const ReadFromStorage = <T>(key: string): T | undefined=> {
    const item = sessionStorage.getItem(key);
    if (item != null) {
        return JSON.parse(item) as T;
    }

    return undefined;
}
